"use client";

import { useState } from "react";
import { PairAvailability } from "@/components/chart/chart-availability";

interface UseMarketCatalogReturn {
  pairAvailability: PairAvailability;
  setPairAvailability: (availability: PairAvailability) => void;
  allTickers: string[];
  setAllTickers: (tickers: string[]) => void;
}

export const useMarketCatalog = (): UseMarketCatalogReturn => {
  const [pairAvailability, setPairAvailability] = useState<PairAvailability>(
    {}
  );
  const [allTickers, setAllTickers] = useState<string[]>([]);

  return {
    pairAvailability,
    setPairAvailability,
    allTickers,
    setAllTickers,
  };
};
